<template>
  <div class="user-management">
    <el-card class="user-card">
      <div slot="header" class="card-header">
        <span>用户管理</span>
      </div>

      <!-- 筛选区域 -->
      <div class="filter-container">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-input v-model="filterForm.id" placeholder="输入ID"></el-input>
          </el-col>
          <el-col :span="5">
            <el-input v-model="filterForm.name" placeholder="输入姓名"></el-input>
          </el-col>
          <el-col :span="5">
            <el-select v-model="filterForm.role" placeholder="选择角色">
              <el-option value="" label="全部角色"></el-option>
              <el-option value="STUDENT" label="学生"></el-option>
              <el-option value="TEACHER" label="教师"></el-option>
              <el-option value="ADMIN" label="管理员"></el-option>
            </el-select>
          </el-col>
          <el-col :span="9">
            <el-button type="primary" @click="fetchUsers">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
            <el-button type="primary" @click="showAddStudentDialog">添加学生</el-button>
            <el-button type="primary" @click="showAddTeacherDialog">添加教师</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 用户表格 -->
      <el-table
        v-loading="loading"
        :data="users"
        border
        style="width: 100%"
        class="users-table"
        fit
        header-align="center"
      >
        <el-table-column prop="id" label="ID" width="120" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" width="150" align="center"></el-table-column>
        <el-table-column prop="role" label="角色" width="100">
          <template #default="scope">
            <el-tag :type="getRoleType(scope.row.role)" size="small">
              {{ getRoleText(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="120" align="center">
          <template #default="scope">
            {{ scope.row.gender || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="grade" label="年级" width="120" align="center">
          <template #default="scope">
            {{ scope.row.grade || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="className" label="班级" width="180" align="center">
          <template #default="{ row }">
            {{ row.className || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" width="220" align="center">
          <template #default="{ row }">
            {{ row.phone || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="账号" width="150" align="center"></el-table-column>
        <el-table-column label="密码" width="120" align="center">
          <template #default>
            ********
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
      <template #default="{ row }">
        <el-button type="text" @click="showEditUserDialog(row)">编辑</el-button>
        <el-button type="text" @click="deleteUser(row)">删除</el-button>
      </template>
    </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 添加学生对话框 -->
    <el-dialog v-model="addStudentDialogVisible" title="添加学生" width="600px">
      <el-form
        ref="studentFormRef"
        :model="studentForm"
        label-width="100px"
      >
        <el-form-item label="账号">
          <el-input v-model="studentForm.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="studentForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="studentForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="studentForm.studentNumber" placeholder="请输入学号"></el-input>
        </el-form-item>
        <el-form-item label="学院">
          <el-input v-model="studentForm.college" placeholder="请输入学院"></el-input>
        </el-form-item>
        <el-form-item label="专业">
          <el-input v-model="studentForm.major" placeholder="请输入专业"></el-input>
        </el-form-item>
        <el-form-item label="班级">
          <el-input v-model="studentForm.className" placeholder="请输入班级"></el-input>
        </el-form-item>
        <el-form-item label="年级">
          <el-input v-model="studentForm.grade" placeholder="请输入年级"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="studentForm.gender" placeholder="请选择性别">
            <el-option value="男" label="男"></el-option>
            <el-option value="女" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="studentForm.contactInfo" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="studentForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="addStudentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitStudentForm">提交</el-button>
      </template>
    </el-dialog>

    <!-- 添加教师对话框 -->
    <el-dialog v-model="addTeacherDialogVisible" title="添加教师" width="600px">
      <el-form
        ref="teacherFormRef"
        :model="teacherForm"
        label-width="100px"
      >
        <el-form-item label="账号">
          <el-input v-model="teacherForm.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="teacherForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="teacherForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="teacherForm.gender" placeholder="请选择性别">
            <el-option value="男" label="男"></el-option>
            <el-option value="女" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教学年级">
          <el-input v-model="teacherForm.teachingGrade" placeholder="请输入教学年级"></el-input>
        </el-form-item>
        <el-form-item label="教学班级">
          <el-input v-model="teacherForm.className" placeholder="请输入教学班级"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="teacherForm.contactInfo" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="teacherForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addTeacherDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTeacherForm">提交</el-button>
      </template>
    </el-dialog>

    <!-- 编辑用户对话框 -->
    <el-dialog v-model="editUserDialogVisible" title="编辑用户" width="600px">
        <el-form
          ref="editUserFormRef"
          :model="editUserForm"
          label-width="100px"
        >
        <el-form-item label="账号">
          <el-input v-model="editUserForm.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="editUserForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="editUserForm.password" type="password" placeholder="请输入密码（不修改请保持为空）"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="editUserForm.gender" placeholder="请选择性别">
            <el-option value="男" label="男"></el-option>
            <el-option value="女" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="editUserForm.contactInfo" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="editUserForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        
        <!-- 学生特有字段 -->
        <el-form-item v-if="editUserForm.role === '学生'" label="年级">
          <el-input v-model="editUserForm.grade" placeholder="请输入年级"></el-input>
        </el-form-item>
        <el-form-item v-if="editUserForm.role === '学生'" label="班级">
          <el-input v-model="editUserForm.className" placeholder="请输入班级"></el-input>
        </el-form-item>
        
        <!-- 教师特有字段 -->
        <el-form-item v-if="editUserForm.role === '教师'" label="教学年级">
          <el-input v-model="editUserForm.grade" placeholder="请输入教学年级"></el-input>
        </el-form-item>
        <el-form-item v-if="editUserForm.role === '教师'" label="教学班级">
          <el-input v-model="editUserForm.className" placeholder="请输入教学班级"></el-input>
        </el-form-item>
        
        <!-- 对于管理员或其他角色，显示基础的年级和班级字段但设为只读 -->
        <template v-if="editUserForm.role !== '学生' && editUserForm.role !== '教师'">
          <el-form-item label="年级">
            <el-input v-model="editUserForm.grade" placeholder="请输入年级" disabled></el-input>
          </el-form-item>
          <el-form-item label="班级">
            <el-input v-model="editUserForm.className" placeholder="请输入班级" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button @click="editUserDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditUserForm">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';

const { proxy } = getCurrentInstance();

// 加载状态
const loading = ref(false);

// 筛选条件
const filterForm = reactive({
  id: '',
  name: '',
  role: ''
});

// 表格数据
const users = ref([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);

// 对话框状态
const addStudentDialogVisible = ref(false);
const addTeacherDialogVisible = ref(false);
const editUserDialogVisible = ref(false);

// 学生表单 - 使用ref而不是reactive以提高性能
const studentForm = ref({
  username: '',
  name: '',
  password: '',
  studentNumber: '',
  college: '',
  major: '',
  className: '',
  grade: '',
  gender: '',
  contactInfo: '',
  email: ''
});

// 教师表单 - 使用ref而不是reactive以提高性能
const teacherForm = ref({
  account: '',
  name: '',
  password: '',
  gender: '',
  teachingGrade: '',
  className: '',
  contactInfo: '',
  email: ''
});

// 编辑用户表单 - 使用ref而不是reactive以提高性能
const editUserForm = ref({
  id: '',
  role: '',
  name: '',
  gender: '',
  contactInfo: '',
  email: '',
  grade: '',
  className: '',
  teachingGrade: '',
  account: '',
  password: ''
});

// 表单引用
const studentFormRef = ref(null);
const teacherFormRef = ref(null);
const editUserFormRef = ref(null);

// 简化为不使用验证规则，提高输入流畅度
const studentRules = {};
const teacherRules = {};
const editUserRules = {};

// 获取角色文本
const getRoleText = (role) => {
  switch (role) {
    case '学生': return '学生';
    case '教师': return '教师';
    case '管理员': return '管理员';
    default: return role;
  }
};

// 获取角色样式
const getRoleType = (role) => {
  switch (role) {
    case '学生': return 'info';
    case '教师': return 'success';
    case '管理员': return 'primary';
    default: return '';
  }
};

// 获取用户列表
const fetchUsers = async () => {
  try {
    loading.value = true;
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      id: filterForm.id || undefined,
      name: filterForm.name || undefined,
      role: filterForm.role || undefined
    };

    const response = await axios.get('/admin/users/list', { params });
    
    // 转换数据格式，适配表格显示
    if (response.data.data && response.data.data.users) {
      users.value = response.data.data.users.map(user => ({
        id: user.userId,
        name: user.userName,
        role: user.role,
        gender: user.gender,
        grade: user.grade,
        teachingGrade: user.teachingGrade,
        className: user.className,
        phone: user.contactInfo,
        username: user.account,
        password: user.password,
        email: user.email
      }));
      total.value = response.data.data.total;
    }
  } catch (error) {
    console.error('获取用户列表失败:', error);
    ElMessage.error('获取用户列表失败');
  } finally {
    loading.value = false;
  }
};

// 重置筛选
const resetFilter = () => {
  filterForm.id = '';
  filterForm.name = '';
  filterForm.role = '';
  currentPage.value = 1;
  fetchUsers();
};

// 分页处理
const handleSizeChange = (size) => {
  pageSize.value = size;
  currentPage.value = 1;
  fetchUsers();
};

const handleCurrentChange = (page) => {
  currentPage.value = page;
  fetchUsers();
};

// 显示添加学生对话框
const showAddStudentDialog = () => {
  // 重置表单
  studentForm.value = {
    username: '',
    name: '',
    password: '',
    studentNumber: '',
    college: '',
    major: '',
    className: '',
    grade: '',
    gender: '',
    contactInfo: '',
    email: ''
  };
  addStudentDialogVisible.value = true;
};



// 显示添加教师对话框
const showAddTeacherDialog = () => {
  // 重置表单
  teacherForm.value = {
    account: '',
    name: '',
    password: '',
    gender: '',
    teachingGrade: '',
    className: '',
    contactInfo: '',
    email: ''
  };
  addTeacherDialogVisible.value = true;
};

// 显示编辑用户对话框
const showEditUserDialog = (user) => {
  // 重置并填充表单数据
  editUserForm.value = {
    id: user.id,
    role: user.role,
    account: user.username || '',
    name: user.name,
    gender: user.gender || '',
    contactInfo: user.phone || '',
    email: user.email || '',
    grade: '',
    className: '',
    teachingGrade: '',
    password: ''
  };
  
  // 根据角色设置不同字段
  if (user.role === '学生') {
    editUserForm.value.grade = user.grade || '';
    editUserForm.value.className = user.className || '';
  } else if (user.role === '教师') {
    editUserForm.value.grade = user.grade || '';
    editUserForm.value.className = user.className || '';
  }
  
  editUserDialogVisible.value = true;
};

// 提交学生表单 - 移除验证以提高流畅度
const submitStudentForm = async () => {
  try {
    // 准备数据格式，直接使用表单数据
    const studentData = {
      account: studentForm.value.username,  // 使用username作为account字段
      name: studentForm.value.name,
      password: studentForm.value.password,
      studentNumber: studentForm.value.studentNumber,
      college: studentForm.value.college,
      major: studentForm.value.major,
      className: studentForm.value.className,
      grade: studentForm.value.grade,
      gender: studentForm.value.gender,
      contactInfo: studentForm.value.contactInfo || '',
      email: studentForm.value.email || ''
    };
    
    // 直接调用指定的后端接口添加学生
    const response = await axios.post('/api/students', studentData);
    ElMessage.success('学生添加成功');
    addStudentDialogVisible.value = false;
    fetchUsers(); // 重新获取用户列表以更新显示
  } catch (error) {
    console.error('提交学生表单失败:', error);
    ElMessage.error('学生添加失败');
  }
};

// 提交教师表单 - 移除验证以提高流畅度
const submitTeacherForm = async () => {
  try {
    // 准备数据格式，直接使用表单数据
    const teacherData = {
      account: teacherForm.value.account,  // 使用account作为账号
      name: teacherForm.value.name,          // 直接使用name作为姓名
      password: teacherForm.value.password,
      gender: teacherForm.value.gender,
      teachingGrade: teacherForm.value.teachingGrade,
      className: teacherForm.value.className,  // 直接使用className作为教学班级
      contactInfo: teacherForm.value.contactInfo || '',
      email: teacherForm.value.email || ''
    };
    
    // 直接调用指定的后端接口添加教师
    const response = await axios.post('/api/teachers', teacherData);
    ElMessage.success('教师添加成功');
    addTeacherDialogVisible.value = false;
    fetchUsers(); // 重新获取用户列表以更新显示
  } catch (error) {
    console.error('提交教师表单失败:', error);
    ElMessage.error('教师添加失败');
  }
};

// 提交编辑用户表单 - 移除验证以提高流畅度
const submitEditUserForm = async () => {
  try {
    // 准备数据格式，直接使用表单数据
    const editData = {
      id: editUserForm.value.id,
      account: editUserForm.value.account,
      name: editUserForm.value.name,
      gender: editUserForm.value.gender,
      contactInfo: editUserForm.value.contactInfo || '',
      email: editUserForm.value.email || '',
      grade: editUserForm.value.grade,
      className: editUserForm.value.className,
      // 确保角色字段不为空，直接使用表单中的角色值
      role: editUserForm.value.role || '学生' // 默认设为学生
    };
    
    // 如果输入了密码，则包含密码字段
    if (editUserForm.value.password) {
      editData.password = editUserForm.value.password;
    }
    
    // 移除teachingGrade字段，教师用户现在使用grade字段
    
    // 直接调用指定的后端接口更新用户信息
    const response = await axios.put(`/admin/users/${editUserForm.value.id}`, editData);
    ElMessage.success('用户更新成功');
    editUserDialogVisible.value = false;
    fetchUsers(); // 重新获取用户列表以更新显示
  } catch (error) {
    console.error('提交编辑用户表单失败:', error);
    ElMessage.error('用户更新失败');
  }
};

// 删除用户
const deleteUser = async (user) => {
  try {
    // 弹出确认对话框
    await ElMessageBox.confirm(
      `确定要删除用户「${user.name}」吗？`,
      '警告',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );
    
    // 转换角色格式：中文到英文
    let role = '';
    switch (user.role) {
      case '学生': 
        role = 'STUDENT';
        break;
      case '教师': 
        role = 'TEACHER';
        break;
      case '管理员': 
        role = 'ADMIN';
        break;
      default:
        role = 'STUDENT';
    }
    
    // 调用删除API，通过query参数传递role
    const response = await axios.delete(`/admin/users/${user.id}`, {
      params: {
        role: role
      }
    });
    
    if (response.data.code === 200) {
      ElMessage.success('删除用户成功');
      fetchUsers(); // 重新获取用户列表以更新显示
    } else {
      ElMessage.error(response.data.message || '删除失败');
    }
  } catch (error) {
    // 如果是用户取消操作，不显示错误提示
    if (error !== 'cancel') {
      ElMessage.error(error.response?.data?.message || '删除用户失败');
    }
  }
};

// 状态管理相关方法已移除

onMounted(() => {
  fetchUsers();
});
</script>

<style scoped>
.user-management {
  padding: 20px;
}

.user-card {
  margin-bottom: 20px;
}

.users-table {
  margin-bottom: 20px;
  width: 100% !important;
  table-layout: fixed;
}

:deep(.el-table__header-wrapper),
:deep(.el-table__body-wrapper) {
  width: 100% !important;
}

:deep(.el-table th.el-table__cell > .cell),
:deep(.el-table td.el-table__cell > .cell) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
</style>